import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PersonList({ label, people, current, onSelect }) {
    return (_jsx("nav", { "aria-label": label, "data-person-list": "", children: _jsx("ul", { style: { listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: "var(--space-025)" }, children: people.map((person) => {
                const here = person.id === current;
                const click = (event) => {
                    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
                        return;
                    event.preventDefault();
                    onSelect(person.id, event.detail === 0);
                };
                return (_jsx("li", { children: _jsxs("a", { href: person.href, "data-person-row": person.id, "aria-current": here ? "page" : undefined, onClick: click, style: {
                            position: "relative",
                            display: "block",
                            // knowledge-page design-spec §3.3: 14px left padding has no token.
                            padding: "var(--space-1) var(--space-15) var(--space-1) 14px",
                            borderRadius: "var(--radius-control)",
                            background: here ? "var(--tone)" : "var(--person-row-bg, transparent)",
                            color: person.deactivated ? "var(--ink-2)" : "var(--ink-1)",
                            textDecoration: "none",
                            fontFamily: "var(--font-sans)",
                            fontSize: "var(--type-body-size)",
                            // knowledge-page design-spec §4.2: row line 1.35.
                            lineHeight: 1.35,
                            fontWeight: here
                                ? "var(--type-body-weight-current)"
                                : person.deactivated
                                    ? "var(--type-body-weight-strong)"
                                    : "var(--type-body-weight)",
                            transitionProperty: "background-color",
                            transitionDuration: "var(--dur-fast)",
                            transitionTimingFunction: "var(--ease-out)",
                        }, children: [here && (_jsx("span", { "aria-hidden": "true", "data-person-bar": "", style: {
                                    position: "absolute",
                                    left: 0,
                                    top: "var(--space-1)",
                                    bottom: "var(--space-1)",
                                    // knowledge-page design-spec §3.3: 3px person bar.
                                    width: "3px",
                                    borderRadius: "var(--radius-bar)",
                                    background: "var(--accent)",
                                } })), _jsx("span", { "data-person-name": "", children: person.name }), person.deactivated && (_jsx("span", { "data-person-deactivated": "", style: {
                                    display: "block",
                                    marginTop: "1px",
                                    color: "var(--ink-2)",
                                    fontSize: "var(--type-small-size)",
                                    // knowledge-page design-spec §4.2: sub-line line 1.4.
                                    lineHeight: 1.4,
                                    fontWeight: "var(--type-small-weight)",
                                }, children: "Deactivated" }))] }) }, person.id));
            }) }) }));
}
